// ACRYLMALL 価格表の設置と切り替え
//
// 価格表の markup は snippets/acrylmall-price-table.liquid が <template> に出す。
// ここでの仕事は、商品説明にあるアンカー <iframe id="priceTable"> を template の
// clone と差し替え、選択肢のクリックで iframe の src を切り替えることだけ。
//
// URL の組み立ても商品ごとの gid の対応表も Liquid 側 (商品メタフィールド) に移った。
// 以前はこのファイルに商品ハンドル → gid のマップを持っていたが、新商品を足すたびに
// テーマを編集して push する必要があり、27 商品が登録漏れで価格表を出せていなかった。
//
// 商品説明に価格表の markup が残っている商品がある。Shopify 管理画面のリッチテキスト
// エディタが <combo-box> カスタム要素と非標準属性を剥がすため、残っていても動かない。
// 差し替えの前に撤去する。

document.addEventListener("DOMContentLoaded", () => {
  const template = document.getElementById("acrylmall-price-table-template");
  const anchor = document.getElementById("priceTable");

  // 撤去より先に両方の存在を確かめる。メタフィールド未設定の商品では template が
  // 無いので、先に撤去すると現に動いている価格表を消してしまう。
  if (!template || !anchor) return;

  removeLegacyPriceTable(anchor);

  const fragment = template.content.cloneNode(true);
  anchor.replaceWith(fragment);
  template.remove();

  const iframe = document.getElementById("priceTable");
  const comboBox = document.getElementById("shipping-day-combo-box");
  const valueSpan = document.getElementById("shipping-day-value");
  if (!iframe || !comboBox || !valueSpan) return;

  comboBox.addEventListener("click", (event) => {
    const option = event.target.closest(".combo-box__option-item");
    if (!option) return;

    // URL を持たない選択肢は無視する。src を空にすると表示中の表が消えるので、
    // 引けないときは何もしない方がよい。
    const url = option.dataset.priceTableUrl;
    if (!url) return;

    iframe.src = url;
    updateShippingDayIcon(valueSpan, option.value);
  });

  const initial = comboBox.querySelector('[aria-selected="true"]');
  if (initial) updateShippingDayIcon(valueSpan, initial.value);
});

// 商品説明に残った価格表 UI を撤去する。
//
// アンカーの直前に隣接する .select-wrapper だけを対象にする。商品説明の別の場所に
// ある無関係な .select-wrapper を巻き込まないため。
//
// 起点をコンボボックスの id に取らないのは、コンボボックスが失われて
// <div class="select-wrapper"></div> の殻だけが残っている商品があるため。
function removeLegacyPriceTable(anchor) {
  const preceding = precedingSiblings(anchor);
  const firstNonBreak = preceding.findIndex((element) => element.tagName !== "BR");
  if (firstNonBreak === -1) return;

  const wrapper = preceding[firstNonBreak];
  if (!wrapper.classList.contains("select-wrapper")) return;

  // 間にあった <br> も一緒に消す。template 側が余白を持っているので、
  // 残すと商品説明の状態によって余白が変わってしまう。
  preceding.slice(0, firstNonBreak + 1).forEach((element) => element.remove());
}

function precedingSiblings(element) {
  const previous = element.previousElementSibling;
  return previous ? [previous, ...precedingSiblings(previous)] : [];
}

// 選択中の発送日に赤丸チェックのアイコンを添える。
function updateShippingDayIcon(valueSpan, selectedValue) {
  valueSpan.innerHTML =
    '<svg width="14" height="14" class="icon icon--chevron" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">' +
    '<circle cx="7" cy="7" r="7" fill="#ff2020"/>' +
    '<path d="M4 7l2 2 4-4" fill="none" stroke="white" stroke-width="1.5"/>' +
    "</svg>" +
    escapeHtml(selectedValue);
}

function escapeHtml(str) {
  return String(str).replace(/[&<>"']/g, (c) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
  })[c]);
}
